import { render, staticRenderFns } from "./answer-complete.vue?vue&type=template&id=0e7ce5fc&scoped=true&"
import script from "./answer-complete.vue?vue&type=script&lang=js&"
export * from "./answer-complete.vue?vue&type=script&lang=js&"
import style0 from "./answer-complete.vue?vue&type=style&index=0&id=0e7ce5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ce5fc",
  null
  
)

export default component.exports